import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
export default class SiteLoginPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.redirecting = false;
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    app.setTitle('Continue to The Hideout');
    app.setTitleCount(0);
    this.continueIfLoggedIn();
  }
  onupdate(vnode) {
    super.onupdate(vnode);
    this.continueIfLoggedIn();
  }
  continueIfLoggedIn() {
    if (app.session.user && !this.redirecting) {
      this.redirecting = true;
      window.location.replace(`${app.forum.attribute('baseUrl')}/hideout/sso/start`);
    }
  }
  clickHeaderButton(itemName) {
    const selector = `.Header-controls .item-${itemName} .Button`;
    const button = document.querySelector(selector);
    if (button instanceof HTMLElement) {
      button.click();
      return;
    }
    console.error(`Flarum header control was not found: ${selector}`);
  }
  openLogin() {
    this.clickHeaderButton('logIn');
  }
  openRegistration() {
    this.clickHeaderButton('signUp');
  }
  view() {
    if (app.session.user || this.redirecting) {
      return m(PageStructure, {
        className: "HideoutSiteLoginPage"
      }, m("div", {
        className: "HideoutSiteLoginContainer"
      }, m("section", {
        className: "HideoutSiteLoginPanel"
      }, m(LoadingIndicator, null), m("h1", null, "Continuing to The Hideout"), m("p", null, "Your forum account has been verified."))));
    }
    return m(PageStructure, {
      className: "HideoutSiteLoginPage"
    }, m("div", {
      className: "HideoutSiteLoginContainer"
    }, m("section", {
      className: "HideoutSiteLoginPanel"
    }, m("div", {
      className: "HideoutSiteLoginLogo"
    }, "H"), m("span", {
      className: "HideoutSiteLoginEyebrow"
    }, "ONE HIDEOUT IDENTITY"), m("h1", null, "Continue to The Hideout"), m("p", {
      className: "HideoutSiteLoginDescription"
    }, "Use your forum account to access the main website, linked accounts, community roles, staff tools, and future game integrations."), m("div", {
      className: "HideoutSiteLoginActions"
    }, m("button", {
      type: "button",
      className: "Button Button--primary",
      onclick: () => this.openLogin()
    }, "Log in"), m("button", {
      type: "button",
      className: "Button",
      onclick: () => this.openRegistration()
    }, "Create account")), m("div", {
      className: "HideoutSiteLoginSecurity"
    }, m("i", {
      className: "fas fa-shield-alt"
    }), m("span", null, "Login and registration are securely handled by The Hideout forum.")))));
  }
}
flarum.reg.add('thehideout-core', 'forum/components/SiteLoginPage', SiteLoginPage);